import SearchComponent from "../../ribPages/SearchData/SearchData";
import CreditSummery from "../../ribPages/Report/CreditSummery";
import DebitSummery from "../../ribPages/Report/DebitSummery";
import MatchedData from "../../ribPages/Report/MatchDataSummery";
import MonthlyProgressiveReport from "../../ribPages/Report/MPRDetails";
import BankDataDownload from "../../ribPages/ExportData/BankDataDownload";
import DetailDataDownload from "../../ribPages/ExportData/DetailDataDownload";
import DebitDataImport from "../../ribPages/ImportData/DebitDataImport";
import SBIDataImport from "../../ribPages/ImportData/SBIDataImport";

export const ribContent = {
  "Search Data": SearchComponent,
  "Credit Data": CreditSummery,
  "Debit Data": DebitSummery,
  "Matched Data": MatchedData,
  "Monthly Progressive Report": MonthlyProgressiveReport,
  "Bank Prepared CSV": BankDataDownload,
  "Unmatched Data": DetailDataDownload,
  "Bank (Cr) Data": SBIDataImport,
  "CRIS (Dr) Data": DebitDataImport,
};
